import { faMagnifyingGlass, faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, {useState} from 'react'

const Section8 = () => {

     const faq = [
        {
          question: "Is Skilleareum free to use?",
          answer:
            "Skilleareum is not free to use. Our platform offers a basic subscription plan called 'AI Genesis,' which provides access to all the exclusive features of Skilleareum and start earning skill points in real time, unlocking a wide range of opportunities to grow and succeed.",
        },
        {
          question:
            "What is the necessity for zK-Proof of Learning (PoL)?",
          answer:
            "Unlike traditional certifications, zK-PoL ensures that your progress and expertise are recorded on a secure, decentralized platform, making them immutable and globally recognized.",
        },
        {
          question: "How can I earn on Skilleareum?",
          answer:
            "You can earn Future Skill Tokens as Skill Points by just staying active on the platform. Earn rewards by completing Skill-Building Daily Challenges, playing Learn & Earn games, referring friends, using AI tools, Exploring AI facts and AI Farming. And that's just the beginning—more exciting activities are coming soon!",
        },
        {
          question:
            "Is Skilleareum suitable for learners of all ages and skill levels?",
          answer:
            "Skilleareum’s platform is accessible to anyone with an internet connection, promoting inclusivity. It likely caters to learners of various ages, backgrounds, and skill levels.",
        },
        {
          question:
            "How can I get support or assistance if I encounter any issues on Skilleareum?",
          answer:
            "For support or assistance, users would typically need to reach out to Skilleareum’s customer service or support team.",
        },
        {
          question: "What are the real use cases of Blockchain in E-learning?",
          answer: `Smart Contracts for Courses and Assignments Enhanced Security-Authentication-Trust P2P Learning and Content Sharing Student Record Keeping with Immutability Cryptocurrency for Rewards
                  Digital Badges and Credentials Ease of Certification Authenticity and Copyrights Protection Reduced Travel Cost
                  Time Convenient Universally Accessible by all`,
        },
        {
          question: "How does Skilleareum enhance the learning experience?",
          answer:
            "Skilleareum integrates technical aspects to validate and reward learning achievements, thereby enhancing the overall learning experience.",
        },
        {
          question: "What is the necessity for Proof of Learning (PoL)?",
          answer:
            "The necessity for PoL lies in ensuring transaction validity and security of skills, tailoring this unique consensus mechanism to the educational context.",
        },
        {
          question: "How does Skilleareum validate learning achievements?",
          answer:
            "Skilleareum validates learning achievements by utilizing the innovative “Proof of Learning” (PoL) consensus mechanism.",
        },
        {
          question: "What is the role of generative AI in Skilleareum?",
          answer:
            "Generative AI aids in acquiring human intelligence on the Skilleareum platform.",
        },
        {
          question: "How does Skilleareum foster user engagement?",
          answer:
            "Skilleareum fosters user engagement through its Tokenised Smart Minting System (SMS).",
        },
        {
          question: "What is the role of blockchain in Skilleareum?",
          answer:
            "Skilleareum employs blockchain technology for global skill validation.",
        },
        {
          question: "What is the role of Social-Fi DAO in Skilleareum?",
          answer:
            "Social-Fi DAO is employed by Skilleareum to foster ethical, personal, and professional growth by providing voting governance and decision-making capacity within the community of Skilleareum ecosystem.",
        },
        {
          question: "How does Skilleareum ensure inclusivity and Transparency?",
          answer:
            "Skilleareum ensures inclusivity through its community-driven model and the use of blockchain technology.",
        },
        {
          question: "What is the vision of Skilleareum?",
          answer:
            "Skilleareum’s vision is to foster ethical, personal, and professional growth, ensuring inclusivity and transparency for users worldwide.",
        },
        {
          question: "What is AI Genesis, and why should I subscribe?",
          answer:
            "AI Genesis is our basic subscription plan that grants you full access to Skilleareum’s exclusive features, including earning skill points, exploring tokenization, and accessing advanced learning tools. It’s your gateway to unlocking the full potential of the Skilleareum platform.",
        },
        {
          question: "What is Skilleareum?",
          answer: "A gamified and incentivized AI learning Socio-EduFi ecosystem powered by blockchain & Web3 (zK-POL & SMS)."
        },
        {
          question: "How does zK-Proof of Learning work?",
          answer: "A gamified learning journey set for all kinds of users for AI learning while maintaining transparency and privacy through zero-knowledge proofs."
        },
        {
          question: "What is SKLRM token?",
          answer: "The SKLRM token serves as a utility, native, and governance token within the ecosystem. It facilitates rewards and manages blockchain-based transactions. Users can mint real-time SKLRM tokens by demonstrating their intellectual efficiency."
        },
        {
          question: "Who can join the platform?",
          answer: "Anyone interested in the platform can join as a Miner to earn incentives. This includes crypto enthusiasts, AI learners, gamers, kids & adults, professionals, individuals, enterprises, and institutions seeking affordable AI upskilling, tool utilization, content creation, and validation of submitted content."
        },
        {
          question: "How will SMS (Smart Minting System) function?",
          answer: "The Smart Minting System (SMS) works in the following steps:\n1. Learning: Users acquire knowledge and skills.\n2. Testing: Users' knowledge is evaluated through SMS.\n3. Proof of Efficiency: The system validates users' performance if they demonstrate proficiency.\n4. Token Generation: Upon validation, a new block is created, and SKLRM tokens are minted through the zK-POL protocol.\n5. Incentive Distribution: The minted tokens are distributed to users as rewards."
        },
        {
          question: "What is the daily % of rewards or incentives or SKLRM tokens from SMS?",
          answer: "For the first five years, a total of 10 million SKLRM tokens will be minted, with 5,479 tokens generated daily. This includes both the token generation and burning mechanisms. After the initial five years, a halving event will occur, reducing the daily minting rate. The halving process will continue for the next 100 years. Each day's tokens are distributed among the active users for that day."
        }
      ];
    
      const [expandedIndex, setExpandedIndex] = useState(0);
     const [searchQuery, setSearchQuery] = useState("");
   
    
      const toggleExpand = (index) => {
        if (expandedIndex === index) {
          setExpandedIndex(0); 
        } else {
          setExpandedIndex(index); 
        }
      };

      const handleSearch = (event) => {
        setSearchQuery(event.target.value);
        setExpandedIndex(-1); 
      };

      
      const filteredFaq = faq.filter((item) => {
        return item.question.toLowerCase().includes(searchQuery.toLowerCase());
      });
   

  return (
    <div className='font-gilroy py-20'>
           <img src='https://skilleareumimages.s3.ap-south-1.amazonaws.com/New/Landing/fan.svg' />
    <div className='  flex md:flex-row flex-col items-center md:items-start gap-10'>
        <div className=' md:w-[40%] '>
         

            <div className='mt-10 flex flex-col justify-center'>
               <p style={{
            backgroundClip: "text",
            color: "transparent",
            backgroundImage: "linear-gradient(to right, #0285FF, #FFFFFF, #FFFFFF, #1EEF32)",
            WebkitBackgroundClip: "text",
          }} className='text-3xl font-semibold'>Have Any Questions in Mind?</p>
         <div className=' relative '>
          <input
            type="text"
            className="w-full focus:outline-none border border-white/20 bg-transparent px-3 py-1.5 rounded-md mt-5"
            placeholder="Search FAQ..."
            value={searchQuery}
            onChange={handleSearch}
          />
          <span className=' absolute top-7 right-3 text-white'>
            <FontAwesomeIcon icon={faMagnifyingGlass} />
          </span>
          </div>
            </div>

            <div className='mt-10 flex justify-center'>
            <div className='relative overflow-hidden flex justify-center items-center'>
        <div className='w-full h-full absolute top-0 '>
            <div className='w-44 mx-auto h-10 absolute top-0 left-0 right-0 opacity-60 bg-[#727272] rounded-full '></div>
            <div className=' w-20 h-16 absolute top-10 -right-10 bg-[#00BA34] opacity-55 rounded-full '></div>
            <div className=' w-7 h-24 absolute top-16 -left-3 bg-[#00BA34] opacity-55 rounded-full '></div>
            <div className='w-44 mx-auto h-10 absolute bottom-0 left-0 right-0 opacity-60 bg-[#3055E3] rounded-full '></div>
        
        </div>
         <div className='w-full h-full flex justify-center items-center bg-[#8989890D] border border-white/5 rounded-2xl backdrop-blur-3xl p-5 '>
         <img
            src="https://skilleareumimages.s3.ap-south-1.amazonaws.com/assets/SKL_MAscot_Wave_Landscape.gif"
            className=" w-10/12 z-30 "
          />
        </div> 
        </div>
            </div>


          
        </div>

        <div className=' md:w-[60%] mx-auto '>
                  <div className=" text-black flex flex-col gap-5 mx-auto">
                         
                          {filteredFaq.slice(0, 5).map((data, index) => (
                            <div
                             
                              className={` ${
                                expandedIndex === index ? "bg-gradient-to-r from-[#17C969] to-[#0285FF] p-[0.9px] " : ""
                              } text-white cursor-pointer rounded-lg duration-500 `}
                            >
                              <div  key={index}
                              onClick={() => toggleExpand(index)}
                              className={`bg-[#0A0A0A] rounded-lg duration-500 px-10  transform transition ease-in-out ${
                                expandedIndex === index ? "h-full" : "h-full"
                              }`}>
                             <div className="flex py-3">
                                <div className="w-[90%]">
                                  <h1 className="font-medium py-2">{data.question}</h1>
                                </div>
                                <div className="w-[10%] flex items-center justify-center">
                                  <button
                                    className="font-bold"
                                   
                                  >
                                    {  expandedIndex === index ? (
                                            <FontAwesomeIcon
                                            icon={faMinus}
                                            className={`transform transition-transform duration-500`}
                                          />
                                    ) : (
                                        <FontAwesomeIcon
                                        icon={faPlus}
                                        className={`transform transition-transform duration-500 `}
                                      />
                                    )}
                                   
                                     
                                  </button>
                                </div>
                              </div>
                              <div
                                className={`duration-300 ease-in-out overflow-hidden ${
                                  expandedIndex === index
                                    ? "py-7 max-h-[300px] border-t border-[#F9F9F9]  rounded-b-md"
                                    : "max-h-0"
                                }`}
                              >
                                <p className="text-sm text-white duration-500">
                                  {data.answer}
                                </p>
                              </div>
                              </div>
                            </div>
                          ))}
                        </div>
            </div>

    
    </div>
    </div>
  )
}

export default Section8